// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".JobContent-module__wrapper___w-YFS{\n  width: 100%;\n  padding: 40px 0 20px 0;\n}\n.JobContent-module__scrollControll___lMHIf {\n  display: flex;\n  max-height: 730px;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  overflow: scroll;\n}\n.JobContent-module__selectionWrapper___GsQ\\+T {\n  display: flex;\n  width: 310px;\n  flex-direction: column;\n  grid-gap: 30px;\n  grid-gap: 30px;\n  gap: 30px;\n  justify-content: center;\n  padding: 32px 0 16px 0;\n  flex-wrap: wrap;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": "JobContent-module__wrapper___w-YFS",
	"scrollControll": "JobContent-module__scrollControll___lMHIf",
	"selectionWrapper": "JobContent-module__selectionWrapper___GsQ+T"
};
export default ___CSS_LOADER_EXPORT___;
